import { Alert, Button, Typography, message } from 'antd';
import React from "react";
import { Link, useFetcher, useOutletContext, useRouteLoaderData } from 'react-router-dom';
import { templateRequest } from '../../../api/order';
import { generateRouteUrl } from '../../../library/constants';
import { ItemClientStatuses } from '../../../library/constants/ItemClientStatuses.js';
import style from './waiting-for-files.module.scss';

const WaitingforFile = () => {
    const { orderDetails, itemDetails } = useRouteLoaderData('OrderManagerDetailsPage')
    const fetcher = useFetcher()
    const { vendorRole, getClientArtworks } = useOutletContext()

    const hasArtwork = itemDetails?.client_status >= ItemClientStatuses.UPLOAD_ARTWORK || orderDetails?.has_artwork;

    return (
        <div className={style.container}>
            <h3>Task for you</h3>

            {(orderDetails.request_for_address !== 2) && <Alert message="Missing delivery address" description="Reminder sent to customer to share the delivery address" type="info" showIcon />}
            {orderDetails.request_for_template === 1 && (
                <Alert message="Customer has requested for product template. Please share it" type="info"
                    action={<Link to={generateRouteUrl('UploadSampleTemplate', {
                        itemId: orderDetails.id,
                    })}>
                        <Button className={style.greenButton}>Send Template to Customer</Button>
                    </Link>}
                />
            )}
            <Alert
                message={hasArtwork ? "Customer has shared artwork." : "Customer has not shared any artwork yet."}
                type="info"
                action={
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <Button className={style.greenButton} onClick={getClientArtworks}>
                            View / Upload Artwork
                        </Button>
                        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                            {hasArtwork ? 'Artwork received' : 'No artwork yet'}
                        </Typography.Text>
                        <Link to={generateRouteUrl('MakeCustomerArtwork', {
                            itemId: orderDetails.id,
                        })}>
                            <Button className={style.greenButton}>Make Digital Proof</Button>
                        </Link>
                    </div>
                }
            />
            <h3>Task to do with {vendorRole}</h3>
            <Alert
                message={
                    orderDetails.request_for_template == 1 ?
                        "Customer has requested for product template please , Request sample template from vendor and send it" :
                        "Request sample template from vendor"}
                type="info"
                action={
                    <Button className={style.greenButton} onClick={() => {
                        fetcher.submit({
                            action: 'resuestTemplateFromVendor'
                        }, {
                            method: 'post'
                        })
                    }} loading={fetcher.state !== 'idle'}>Request Template</Button>
                }
            />
        </div>
    )
}
WaitingforFile.Actions = {
    resuestTemplateFromVendor: async ({ params }) => {
        const { itemId } = params
        try {
            const { message: msg } = await templateRequest(itemId, [])
            message.success(msg);
            return true
        }
        catch (error) {
            message.error(error.message)
        }
        return false
    },
}
export default WaitingforFile;